<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">{{__('Dashboard')}}</h1>
    <p class="mb-8 leading-normal">{{__('Hey there! Welcome to O-NOW by Innovastore International.')}} </p>
    <div>
        <img src="/images/openingspagina.jpg" />
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
}
</script>
